/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
var dingTalk = (function (options, context) {
    var api = 'dd.biz.chat.openSingleChat';
    context.DDCall(api, options);
});

export { dingTalk as default };
